// For Single Reel Configurations
export const REEL_COLLECTION_COUNT = 2;
export const REEL_NUMBERS = 5;
export const SYMBOLS_PER_REEL = 5;
export const SYMBOL_WIDTH = 195;
export const SYMBOL_HEIGHT = 140;
export const REEL_WIDTH = SYMBOL_WIDTH;
export const REEL_DIVIDER = 5;

// For Double Reel Configurations
export const HOLDSPIN_SYMBOL_WIDTH = 195;//149;
export const HOLDSPIN_SYMBOL_HEIGHT = 140;//126;
export const HOLDSPIN_REEL_WIDTH = HOLDSPIN_SYMBOL_WIDTH;
export const HOLDSPIN_REEL_DIVIDER = 5;
export const HOLDSPIN_ROW_DIVIDER = 0;
export const DOUBLE_REEL_GAP = 37;

export const REEL_FRAME = 0;
export const NUMBER_OF_SYMBOLS = 11;
export const SHOWN_REELS_HEIGHT = SYMBOL_HEIGHT * SYMBOLS_PER_REEL;

export const SYMBOLS_PER_REEL_DOUBLE = 6;

// Max Game height Width
export const MaxGameWidthHeight = 2048;

export class SYMBOL_IDS {
    static readonly Gold_Coin = 22;
    static readonly Blank_Coin = 23;

    // Special Symbol ids
    static readonly ZEUS = 13;
    static readonly ZEUS_COLLECTOR = 16;
    static readonly ZEUS_PERSISTENT_COLLECTOR = 17;
    static readonly ZEUS_COLLECTOR_CONSUMED = 24;

    static readonly HADES = 14;
    static readonly HADES_DOUBLER = 18;
    static readonly HADES_PERSISTENT_DOUBLER = 19;
    static readonly HADES_DOUBLER_CONSUMED = 25;

    static readonly POSEIDON = 15;
    static readonly POSEIDON_ADDER = 20;
    static readonly POSEIDON_PERSISTENT_ADDER = 21;
    static readonly POSEIDON_ADDER_CONSUMED = 26;
}

export const REEL_BG_POS_ALL = [
    {
        "3": { bgX: 248, bgY: 230, bgScaleX: 1, bgScaleY: 0.67, reelX: 0, reelY: -983 }
    },
    {
        "4": { bgX: 248, bgY: 230, bgScaleX: 1, bgScaleY: 0.67, reelX: 0, reelY: -983 }
    },
    {
        "5": { bgX: 248, bgY: 165, bgScaleX: 1, bgScaleY: 0.84, reelX: 212, reelY: -983 }
    },
    {
        "6": { bgX: 248, bgY: 80, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -983 }
    },
    {
        "7": { bgX: 248, bgY: 0, bgScaleX: 1, bgScaleY: 1.15, reelX: 0, reelY: -983 }
    },
    {
        "8": { bgX: 248, bgY: -103, bgScaleX: 1, bgScaleY: 1.34, reelX: 0, reelY: -983 }
    },
    {
        "9": { bgX: 248, bgY: -103, bgScaleX: 1, bgScaleY: 1.34, reelX: 0, reelY: -983 }
    },
    {
        "10": { bgX: 248, bgY: -103, bgScaleX: 1, bgScaleY: 1.34, reelX: 0, reelY: -983 }
    }
];

export const REEL_SCALE_LANDSCAPE = [1, 1, 0.8, 0.7, 0.6, 0.5, 0.5, 0.5];
export const REEL_SCALE_PORTRAIT = [0.8, 0.8, 0.8, 0.8, 0.77, 0.75, 0.73, 0.71];

export let VISIBLE_SYMBOLS_PER_REEL = 3;
export let setVisibleSymbols = (newValue: number) => {
    VISIBLE_SYMBOLS_PER_REEL = newValue;
};